<template>
  <div class="register-body">
    <!-- 顶部渐变导航 -->
    <div class="header"></div>

    <!-- 品牌区 -->
    <div class="tu">
      <img src="../assets/img/logo.png" style="width: 60px;" alt="logo">
      <img src="../assets/img/logo1.png" style="width: 180px;">
    </div>

    <div class="box">
      <svg viewBox="0 0 200 200" version="1.1">
        <text font-family="爱心字体, sans-serif" x="50%" y="55%" text-anchor="middle">粉裙星物语</text>
      </svg>
    </div>

    <!-- 注册卡片 -->
    <div class="registerDiv">
      <div class="register-content">
        <h1 class="register-title chou_text_color2">开启梦境之旅</h1>
        <el-form :model="regForm" label-width="80px" :rules="rules" ref="regForm">
          <el-form-item label="账号" prop="no">
            <el-input style="width: 220px" type="text" v-model.trim="regForm.no" placeholder="3-20位，登录用"
                      autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="昵称" prop="name">
            <el-input style="width: 220px" type="text" v-model.trim="regForm.name" placeholder="展示名字"
                      autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="密语" prop="password">
            <el-input style="width: 220px" type="password" v-model="regForm.password" placeholder="3-20位"
                      show-password autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="确认密语" prop="confirmPassword">
            <el-input style="width: 220px" type="password" v-model="regForm.confirmPassword" placeholder="再次输入密语"
                      show-password autocomplete="off" size="small" @keyup.enter.native="submit"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input style="width: 220px" type="text" v-model.trim="regForm.phone" placeholder="用于找回账号"
                      autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="年龄" prop="age">
            <el-input style="width: 220px" type="text" v-model.trim="regForm.age" placeholder="选填"
                      autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="性别">
            <el-radio-group v-model="regForm.sex">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="0">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item style="margin-top: 12px">
            <el-button type="primary" @click="submit" :loading="submitting">注 册</el-button>
            <el-button @click="backToLogin">返回登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { register, findByNo } from '../api/user'

export default {
  name: 'Register',
  data() {
    // 账号查重校验（编辑场景不校验）
    const checkDuplicate = (rule, value, callback) => {
      findByNo(value).then(res => {
        if (res.code === 200) {
          callback(new Error('该账号已存在，请更换'))
        } else {
          callback()
        }
      }).catch(() => callback())
    }
    // 确认密码校验
    const checkConfirm = (rule, value, callback) => {
      if (value !== this.regForm.password) {
        callback(new Error('两次输入的密语不一致'))
      } else {
        callback()
      }
    }
    return {
      submitting: false,
      regForm: {
        no: '',
        name: '',
        password: '',
        confirmPassword: '',
        phone: '',
        age: '',
        sex: 1
      },
      rules: {
        no: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' },
          { validator: checkDuplicate, trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入昵称', trigger: 'blur' },
          { max: 20, message: '昵称最长 20 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密语', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入密语', trigger: 'blur' },
          { validator: checkConfirm, trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        age: [
          { pattern: /^([1-9][0-9]?|1[0-4][0-9]|150)$/, message: '年龄需为 1-150 的整数', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submit() {
      this.$refs.regForm.validate((valid) => {
        if (!valid) return
        this.submitting = true
        const payload = {
          no: this.regForm.no,
          name: this.regForm.name,
          password: this.regForm.password,
          phone: this.regForm.phone,
          sex: this.regForm.sex
        }
        if (this.regForm.age !== '') {
          payload.age = Number(this.regForm.age)
        }
        register(payload).then(res => {
          if (res.code === 200) {
            this.$message({ type: 'success', message: '注册成功，欢迎来到粉裙星物语！' })
            setTimeout(() => this.$router.replace('/'), 1200)
          } else {
            this.$message({ type: 'error', message: res.msg || '注册失败' })
          }
        }).catch(err => {
          this.$message({ type: 'error', message: err.message || '网络异常，请稍后重试' })
        }).finally(() => {
          this.submitting = false
        })
      })
    },
    backToLogin() {
      this.$router.replace('/')
    }
  }
}
</script>

<style scoped>
.register-body {
  width: 100%;
  height: 100vh;
  overflow: auto;
  background: linear-gradient(160deg, #ffe6ef, #fff0f8);
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  z-index: 998;
  background: linear-gradient(45deg, #bafff2, #affcc1, #90e8fc, #fcbce8, #8fbdf6, #dda0f1);
  background-size: 400% 400%;
  animation: gradientFlowDiagonal 15s ease infinite;
}

@keyframes gradientFlowDiagonal {
  0% { background-position: 0% 0%; }
  50% { background-position: 100% 100%; }
  100% { background-position: 0% 0%; }
}

.tu {
  position: fixed;
  top: 2px;
  left: 30px;
  z-index: 999;
  display: flex;
  align-items: center;
}

.box {
  position: absolute;
  top: 112px;
  width: 100%;
  height: 240px;
}

svg {
  width: 100%;
  height: 100%;
}

@font-face {
  font-family: '爱心字体';
  src: url('../assets/fonts/爱心字体.ttf') format('truetype');
}

svg text {
  font-size: 100px;
  fill: rgba(148, 74, 0, 0);
  stroke-width: 2px;
  stroke: rgb(121, 210, 241);
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: txtain-loop 15s infinite;
  animation-timing-function: linear;
}

@keyframes txtain-loop {
  0% { stroke-dashoffset: 1000; }
  44.44% { stroke-dashoffset: 0; }
  44.44%, 100% { stroke-dashoffset: 0; animation-timing-function: steps(1, end); }
}

.registerDiv {
  position: absolute;
  top: 500px;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 450px;
  padding: 26px 0;
  background: linear-gradient(45deg, rgba(85, 210, 255, 0.7), rgba(250, 248, 252, 0.68), rgba(250, 123, 172, 0.65));
  border-radius: 5%;
}

.register-content {
  width: 400px;
  margin: 0 auto;
}

.chou_text_color2 {
  background-image: -webkit-linear-gradient(left, pink, #7edbff 10%, #f16a9d 20%, #fa5d50 30%, #C0B2FC 40%, #98E4FB 50%, #C0B2FC 60%, #fa5d50 70%, #f16a9d 80%, #7edbff 90%, pink 100%);
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
  -webkit-background-size: 200% 100%;
  -webkit-animation: chou_text_color 4s linear infinite;
}

@keyframes chou_text_color {
  0% { background-position: 0 0; }
  100% { background-position: -100% 0; }
}

.register-title {
  font-size: 28px;
  margin-bottom: 24px;
  text-align: center;
}
</style>
